<template>
  <div class="building">
    <the-hero :cover="cover" :link="link"></the-hero>
  </div>
</template>

<script>
import TheHero from '@/components/TheHero.vue';

import Cover from '@/assets/images/cover.jpg';

export default {
  name: 'building',
  components: {
    TheHero,
  },
  data() {
    return {
      cover: Cover,
      link: {
        href: 'mailto:info@bgsestudiojuridico.com',
        text: 'Contáctanos Aquí',
      },
    };
  },
};
</script>
